import { Lightbulb, Stethoscope } from "lucide-react";
import { SYMPTOM_TIPS, FLOW_TIPS, MOOD_TIPS } from "@/lib/symptom-tips";

export const TipItem = ({ name, tip, doctor, testId }) => (
  <li className="rounded-2xl bg-[#FBF5EE] p-4" data-testid={testId}>
    <p className="flex items-center gap-2 text-sm font-semibold text-[#2C221E]"><Lightbulb className="h-4 w-4 text-[#9E4429]" /> {name}</p>
    <p className="mt-1.5 text-sm leading-relaxed text-[#3D302B]">{tip}</p>
    {doctor && <p className="mt-2 flex items-start gap-2 text-xs leading-relaxed text-[#6B5A52]"><Stethoscope className="mt-0.5 h-3.5 w-3.5 shrink-0" />{doctor}</p>}
  </li>
);

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export const SymptomTips = ({ log }) => {
  const items = [
    ...(log.symptoms ?? []).map((s) => [s, SYMPTOM_TIPS[s]]),
    ...(log.flow && FLOW_TIPS[log.flow] ? [[`${log.flow} flow`, FLOW_TIPS[log.flow]]] : []),
    ...(log.mood && MOOD_TIPS[log.mood] ? [[`Feeling ${log.mood.toLowerCase()}`, MOOD_TIPS[log.mood]]] : []),
  ].filter(([, t]) => t);
  if (!items.length) return null;
  return (
    <div className="mt-5" data-testid="symptom-tips">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#9E4429]">What may help</p>
      <ul className="mt-2 space-y-2">
        {items.map(([name, t]) => <TipItem key={name} name={name} tip={t.tip} doctor={t.doctor} testId={`symptom-tip-${slug(name)}`} />)}
      </ul>
    </div>
  );
};
